import React from "react"

const QpBackPanel = ({ fillColor, strokeColor }) => (
  <g id="back-panel">
    <path fill={fillColor} d="M391 233.6c0-18.8-1.4-33.2-7.2-62.3-7.4-47.2-47.9-78.7-292.6-110-16.8-2.2-33.9-1.9-50.7.6 0 0-13-2.1-32.4 32.1 0 0-6 9.1-5.6 48.9.3 39.8 15.1 358.5 15.1 358.5s4.8 48.7 108.8 74.9c20.8 8.2 42.4 16.3 61 23.2 28.4 10.5 49.7 18 49.7 18s116 21 133-11 20-52 20-67v-157c-.1 0 6.5-80.7.9-148.9Z" fillRule="nonzero"/>
    <g stroke={strokeColor} strokeLinecap="round" strokeLinejoin="round">
      <path d="M391 233.6c0-18.8-1.4-33.2-7.2-62.3-7.4-47.2-47.9-78.7-292.6-110-16.8-2.2-33.9-1.9-50.7.6 0 0-13-2.1-32.4 32.1 0 0-6 9.1-5.6 48.9.3 39.8 15.1 358.5 15.1 358.5s4.8 48.7 108.8 74.9c20.8 8.2 42.4 16.3 61 23.2 28.4 10.5 49.7 18 49.7 18s116 21 133-11 20-52 20-67v-157c-.1 0 6.5-80.7.9-148.9Z" strokeWidth="3" strokeMiterlimit="10"/>
    </g>
  </g>
)

export default QpBackPanel
